import { HttpClient } from '@angular/common/http';
import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { firstValueFrom } from 'rxjs';
import { IconPath } from '../../../app.constants';

declare global {
  interface Window {
    IcamKbChat?: {
      init(options: { getToken: () => Promise<string>; button?: string }): void;
      open(): void;
      close(): void;
      toggle(): void;
      setLang(lang: string): void;
      destroy(): void;
      openKnowledgeBase(where?: { model?: string; section?: string; lang?: string }): Promise<void>;
    };
  }
}

/** Loaded once per page, shared across every mount/unmount of the bubble. */
let kbChatScriptLoad: Promise<void> | null = null;

function loadKbChatScript(src: string): Promise<void> {
  if (!kbChatScriptLoad) {
    kbChatScriptLoad = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.body.appendChild(script);
    });
  }
  return kbChatScriptLoad;
}

@Component({
  selector: 'app-knowledge-base-bubble',
  templateUrl: './knowledge-base-bubble.component.html',
  styleUrl: './knowledge-base-bubble.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KnowledgeBaseBubbleComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);

  iconPath = `${IconPath}knowledge-base-white.svg`;

  ngOnInit(): void {
    loadKbChatScript(environment.knowledgeBaseScriptUrl)
      .then(() => {
        window.IcamKbChat?.init({
          getToken: () =>
            firstValueFrom(this.http.get<{ token: string }>(`${environment.apiBaseUrl}/kb-token`)).then(
              (response) => response.token
            ),
          button: '.knowledge-base-bubble'
        });
      })
      .catch((error) => console.error('[KnowledgeBaseBubble] Failed to load chat widget', error));
  }

  ngOnDestroy(): void {
    window.IcamKbChat?.destroy();
  }
}
